/**
 * WalterGO Navigation Umami-Tracker
 * Spec: analytics/tracking-spec.md §3.1
 *
 * EVENTS:
 *   nav.menu.open          position: 'header' | 'footer'
 *   nav.menu.link_click    cta_label
 *   nav.search.open        —
 *   nav.search.submit      query_length  (NICHT der Text)
 *   nav.cart.open          —
 *   nav.logo_click         position: 'header' | 'footer'
 *   footer.link_click      cta_label, category: 'legal' | 'social' | 'shop' | 'other'
 *
 * Selektor-Konvention (WalterGO-Theme):
 *   Header-Logo:    a.header-waltergo__logo
 *   Header-Menu-Link: a.header-waltergo__nav-link, a.header-waltergo__mobile-nav-link
 *   Header-Menu-Toggle (mobile): button[data-mobile-menu-toggle]
 *   Footer-Link:    a.footer-waltergo__link
 *   Footer-Logo:    .footer-waltergo__logo (Text, kein Link)
 *   FAB Cart:       a.waltergo-fab__cart (oder a[href="/cart"] global)
 *   FAB Search:     a[href="/search"] in waltergo-fab
 *   Search-Form:    form[action="/search"], predictive-search form
 */
(function () {
  'use strict';

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  function classifyFooterCategory(url, label) {
    var u = (url || '').toLowerCase();
    var l = (label || '').toLowerCase();
    if (/impressum|datenschutz|agb|widerruf|policies|policy|legal/.test(u)) return 'legal';
    if (/impressum|datenschutz|agb|widerruf|rechtlich/.test(l)) return 'legal';
    if (/facebook|instagram|tiktok|twitter|x\.com|linkedin|pinterest|youtube/.test(u)) return 'social';
    if (/products|collections|pages\/(?!impressum|datenschutz|agb)/.test(u)) return 'shop';
    return 'other';
  }

  function init() {
    // -- Logo-Klick (Header + Footer) — strikte Klassen-Selektoren,
    //    KEINE href$="/"-Fallbacks (würden Menü-Links auf /products/ falsch erfassen)
    document.addEventListener('click', function (e) {
      if (e.target.closest('a.header-waltergo__logo')) {
        track('nav.logo_click', { position: 'header' });
        return;
      }
      if (e.target.closest('footer a.footer-waltergo__logo, footer a.footer-waltergo__logo-link')) {
        track('nav.logo_click', { position: 'footer' });
      }
    });

    // -- Header Menu-Link (Desktop + Mobile)
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a.header-waltergo__nav-link, a.header-waltergo__mobile-nav-link');
      if (link) {
        track('nav.menu.link_click', { cta_label: (link.textContent || '').trim().slice(0, 50) });
      }
    });

    // -- Mobile Menu Toggle (Header)
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-menu-toggle], button.header__menu-toggle, summary.header__menu');
      if (toggle) {
        // Nur Open feiern, nicht Close — aria-expanded false → true
        var expanded = toggle.getAttribute('aria-expanded');
        // Wenn der Toggle gerade auf false steht (= wird gleich geöffnet), feuern
        if (expanded === 'false') {
          track('nav.menu.open', { position: 'header' });
        }
      }
    });

    // -- Cart-Icon-Klick (FAB + Standard)
    // Note: cart-tracker.js feuert cart.drawer.open mit trigger='icon' — hier zusätzlich nav.cart.open
    document.addEventListener('click', function (e) {
      var cart = e.target.closest(
        'a.waltergo-fab__cart, a[href$="/cart"], a[href$="/cart/"], ' +
        '.header__icon--cart, summary.header__icon--cart, #cart-icon-bubble'
      );
      if (cart) track('nav.cart.open');
    });

    // -- Search-Icon / Search-Modal-Open — auf interaktive Elemente einschränken,
    //    sonst würde [aria-label*="search"] beliebige Tags matchen
    document.addEventListener('click', function (e) {
      var searchOpen = e.target.closest(
        'a[href$="/search"], a[href*="/search?"], ' +
        '.header__icon--search, summary.header__icon--search, ' +
        'a[aria-label*="search"], a[aria-label*="Search"], a[aria-label*="Suche"], ' +
        'button[aria-label*="search"], button[aria-label*="Search"], button[aria-label*="Suche"], ' +
        'summary[aria-label*="search"], summary[aria-label*="Search"], summary[aria-label*="Suche"]'
      );
      // Exclude submit-Buttons innerhalb von Search-Forms
      if (searchOpen && !e.target.closest('form')) {
        track('nav.search.open');
      }
    });

    // -- Search-Submit (Form-Submit, query_length statt query)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      var isSearch = /\/search/.test(action) || form.closest('predictive-search, search-form');
      if (!isSearch) return;
      var q = form.querySelector('input[name="q"], input[type="search"]');
      var len = q ? (q.value || '').length : 0;
      track('nav.search.submit', { query_length: len });
    }, true);

    // -- Footer-Link-Klick
    document.addEventListener('click', function (e) {
      var link = e.target.closest('footer a[href], .footer-waltergo a[href]');
      if (!link) return;
      // Logo-Klicks separat behandelt → hier ausschließen
      if (link.closest('a.footer-waltergo__logo')) return;
      var label = (link.textContent || '').trim().slice(0, 50);
      var category = classifyFooterCategory(link.getAttribute('href'), label);
      track('footer.link_click', { cta_label: label, category: category });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
